<template>
  <div id="app">
    <router-view />
    <footer>
      <p>
        <span class = "foot">© 2020 コロナにまけるな</span>
        <span class = "foot">短編小説コンテスト実行委員会</span>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {}
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;

  min-height: 100%;
  position: relative; /*←相対位置*/
  padding-bottom: 100px; /*←footerの高さ*/
  box-sizing: border-box; /*←全て含めてmin-height:100vhに*/
}

footer {
  width: 100%;
  background-color: #2c3e50;
  color: #fff;
  text-align: center;
  padding: 0px;

  position: absolute; /*←絶対位置*/
  bottom: 0; /*下に固定*/
}
</style>
<style scoped>
.foot{
  display: inline-block;
}
</style>
